import { onGroundTransportActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { GroundTransportActivityCard } from "./GroundTransportActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  groundTransportId: number
  config: server.dto.ActivityPanelConfig
}

export const GroundTransportActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  return <ActivityPanel<server.dto.GroundTransportActivity>
    activityKey="groundTransport"
    itemId={props.groundTransportId}
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.GroundTransport.ListActivity({ itemId: props.groundTransportId, page, perPage })}
    renderActivity={(activity => <GroundTransportActivityCard
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onGroundTransportActivity}
    onActivity={(activity) => {
      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}
